const CHAT_LINK_PATTERN = /(?:https?:\/\/|www\.)[^\s<]+/gi;
const TRAILING_LINK_PUNCTUATION = /[.,!?;:\u3001\u3002\uff0c\uff01\uff1f\uff1b\uff1a)\]\}\uff09\u3011\u300b]+$/;
const CHAT_PHONE_PATTERN = /(?:\+\d[\d\s().-]{6,}\d|(?<![\p{L}\p{N}])0\d[\d\s().-]{6,}\d)/gu;

function normalizePhoneHref(value) {
  const withoutDomesticPrefix = value.replace(/^\+81\s*\(0\)/, "+81");
  const normalized = withoutDomesticPrefix.replace(/(?!^)\D/g, "");
  const digitCount = normalized.replace(/\D/g, "").length;

  if (normalized.startsWith("+") && digitCount >= 8 && digitCount <= 15) {
    return `tel:${normalized}`;
  }
  if (normalized.startsWith("0") && digitCount >= 10 && digitCount <= 11) {
    return `tel:${normalized}`;
  }
  return null;
}

function parsePhoneSegments(value) {
  const segments = [];
  let cursor = 0;
  let match;

  CHAT_PHONE_PATTERN.lastIndex = 0;
  while ((match = CHAT_PHONE_PATTERN.exec(value)) !== null) {
    const href = normalizePhoneHref(match[0]);
    if (!href) continue;

    if (match.index > cursor) {
      segments.push({ type: "text", value: value.slice(cursor, match.index) });
    }
    segments.push({ type: "phone", value: match[0], href });
    cursor = match.index + match[0].length;
  }

  if (cursor < value.length) {
    segments.push({ type: "text", value: value.slice(cursor) });
  }
  return segments.length > 0 ? segments : [{ type: "text", value }];
}

export function parseChatMessageLinks(value = "") {
  const text = String(value || "");
  const segments = [];
  let cursor = 0;
  let match;

  CHAT_LINK_PATTERN.lastIndex = 0;
  while ((match = CHAT_LINK_PATTERN.exec(text)) !== null) {
    if (match.index > cursor) {
      segments.push(...parsePhoneSegments(text.slice(cursor, match.index)));
    }

    const matchedValue = match[0];
    const linkText = matchedValue.replace(TRAILING_LINK_PUNCTUATION, "");
    const trailingText = matchedValue.slice(linkText.length);

    if (linkText) {
      segments.push({
        type: "link",
        value: linkText,
        href: /^www\./i.test(linkText) ? `https://${linkText}` : linkText,
      });
    }
    if (trailingText) {
      segments.push({ type: "text", value: trailingText });
    }

    cursor = match.index + matchedValue.length;
  }

  if (cursor < text.length) {
    segments.push(...parsePhoneSegments(text.slice(cursor)));
  }

  return segments.length > 0 ? segments : [{ type: "text", value: text }];
}
